import { Box, Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import applyType from '../../utils/metadataUtils';
import { generateRandomString } from '../../utils/string';
import { jsonPathToValue } from '../../utils/json';
import { RootState } from '../../redux/store';
import useMetaData from '../../hooks/useMetaData';
import { getCustomer } from '../../services/vehicles';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import TabLoader from './TabLoader';
import GridLabels from '../VehicleVerticalTabs/GridLabels';

const Customer = () => {
  const [data, setData] = useState<any>();
  const { reservationId } = useParams<{ reservationId: string }>();
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.customerDetailsTabs);
  const email = useSelector((state: RootState) => state.vehicle.data.email);

  useEffect(() => {
    if (email) {
      getCustomer(email, reservationId!).then((response) => setData(response));
    }
  }, [email]);

  if (!metaData || !data) {
    return <TabLoader loop={9} />;
  }

  const customer =
    metaData?.customerDetails?.rows?.map((row: any) => ({
      label: row.propertyName,
      title: applyType(row.type, jsonPathToValue(data, row.property)),
      id: generateRandomString(10),
      isOptional: row.isOptional,
    })) || [];

  const profile =
    metaData?.profile?.rows?.map((row: any) => {
      return {
        label: row.propertyName,
        title: jsonPathToValue(data, row.property),
        id: generateRandomString(10),
        isOptional: row.isOptional,
      };
    }) || [];

  return (
    <Grid container spacing={2} mt={1}>
      <Typography sx={{ fontSize: '16px', fontWeight: '500', padding: '5px 0 0 16px', width: '100%' }}>
        Customer Details
      </Typography>

      <GridLabels
        labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
        titleSx={{
          fontSize: '16px',
          fontWeight: '500',
          color: '#3E3E3E',
        }}
        labels={[...customer]}
      />
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Typography sx={{ fontSize: '16px', fontWeight: '500', padding: '15px 0 0 16px', width: '100%' }}>
        Profile
      </Typography>
      <GridLabels
        labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
        titleSx={{
          fontSize: '16px',
          fontWeight: '500',
          color: '#3E3E3E',
        }}
        labels={[...profile]}
      />
      <Grid item xs={12}>
        <Divider />
      </Grid>
      {/* <Typography sx={{ fontSize: '16px', fontWeight: '500', padding: '15px 0 0 16px', width: '100%' }}>
        Contact History
      </Typography> */}

      {/* <Grid item xs={12} sx={{ paddingBottom: '30px' }}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            border: '1px solid #E3E3E3',
            padding: '10px 10px 9px 17px',
            borderRadius: '6px',

            paddingLeft: '55px',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              left: '10px',
              top: '13px',
              width: '32px',
              height: '32px',
              borderRadius: '50px',
              backgroundColor: '#E1E9F4',
              border: '3px solid #FFFFFF',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Icon icon="carbon:phone" width="20" />
          </Box>
          <Grid container sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: '400',
                  color: '#3E3E3E',
                }}
              >
                Phone call on Jun 12, 2022
              </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#717171',
                }}
              >
                Congratulation call, contact by Paul Nelson
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid> */}
    </Grid>
  );
};

export default Customer;
